<template>
  <div>
    <v-row class="mt-5 pl-3">
      <h3 class="mt-1">シーンのタイトル</h3>
      <v-text-field
        dense
        outlined
        v-model="title"
        ref="titleSection"
        :disabled="!editSection || loaddingEditSectionTitle"
        class="max-width-3 mx-5"
        @keydown.enter="handleUpdateSection"
        autofocus
        v-on:blur="handleCancelUpdate"
      >
        <template v-slot:append>
          <v-icon
            v-if="editSection && !loaddingEditSectionTitle"
            @click="handleUpdateSection"
            >fas fa-check</v-icon
          >
          <v-progress-circular
            v-if="loaddingEditSectionTitle"
            class="ma-0"
            size="25"
            :width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </template>
      </v-text-field>
      <v-btn
        class="pt-1"
        v-if="!editSection"
        icon
        @click="onClickEditSectionTitle"
      >
        <v-icon>fas fa-pencil-alt</v-icon>
      </v-btn>
      <v-spacer />
    </v-row>
    <!-- タイトル（かな） -->
    <v-row class="mt-5 pl-3">
      <h3 class="mt-1">シーンのタイトル（かな）</h3>
      <v-text-field
        dense
        outlined
        v-model="titleKana"
        ref="titleSectionKana"
        :disabled="!editSectionKana || loaddingEditSectionTitleKana"
        class="max-width-3 mx-5"
        @keydown.enter="handleUpdateSectionKana"
        autofocus
        v-on:blur="handleCancelUpdate"
      >
        <template v-slot:append>
          <v-icon
            v-if="editSectionKana && !loaddingEditSectionTitleKana"
            @click="handleUpdateSectionKana"
            >fas fa-check</v-icon
          >
          <v-progress-circular
            v-if="loaddingEditSectionTitleKana"
            class="ma-0"
            size="25"
            :width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </template>
      </v-text-field>
      <v-btn
        class="pt-1"
        v-if="!editSectionKana"
        icon
        @click="onClickEditSectionTitleKana"
      >
        <v-icon>fas fa-pencil-alt</v-icon>
      </v-btn>

      <v-spacer />
    </v-row>
    <!-- Goal -->
    <v-row>
      <v-col>
        <Goal @setDefault="setDefault" ref="goal" />
      </v-col>
    </v-row>
    <!-- Grammar -->
    <v-row>
      <v-col>
        <GrammarList />
      </v-col>
    </v-row>
    <!-- Lead Sentence -->
    <v-row>
      <v-col>
        <LeadSentence ref="lead_sentence" @setDefault="setDefault" />
      </v-col>
    </v-row>
    <!-- Skit -->
    <v-row>
      <v-col>
        <Skit />
      </v-col>
    </v-row>
    <!-- Expression -->
    <v-row>
      <v-col>
        <Expression />
      </v-col>
    </v-row>
    <!-- General Exercises -->
    <v-row>
      <v-col>
        <GeneralExercises />
      </v-col>
    </v-row>
    <!-- Dialog confirm save -->
    <v-dialog v-model="editDetailSection.statusEdit" persistent max-width="340">
      <v-card>
        <v-card-title class="headline">確認</v-card-title>
        <v-card-text>学習目標を保存します。よろしいですか。</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="handleNoComfirm">{{ $t("NO") }}</v-btn>
          <v-btn small color="primary" @click="handleYesConfirm">{{
            $t("YES")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import mixin from "@/mixin";
import Goal from "@/views/listSection/Goal";
import GrammarList from "@/views/listSection/Grammar/GrammarList";
import LeadSentence from "@/views/listSection/LeadSentence";
import GeneralExercises from "@/views/listSection/GeneralExercises";
import Skit from "@/views/listSection/Skit/Skit";
import Expression from "@/views/listSection/Expression/Expression";
import { updateSection } from "@/api/Section.api";
import { createConversation } from "@/api/Conversation.api";
import NProgress from "nprogress";
NProgress.configure({ showSpinner: false });
export default {
  directives: { focus },
  mixins: [mixin.App, mixin.DetailSection],
  store: ["detailsSection", "editDetailSection"],
  components: {
    Goal,
    GrammarList,
    LeadSentence,
    Skit,
    Expression,
    GeneralExercises,
  },
  data() {
    return {
      editSection: false,
      loaddingEditSectionTitle: false,
      editSectionKana: false,
      loaddingEditSectionTitleKana: false,
      title: "",
      titleKana: "",
      redirect: {},
      redirectFrom: {},
    };
  },
  async beforeRouteUpdate(to, from, next) {
    let checkEditLeadSentence = this.editDetailSection.lead_sentence.find(
      (e) => e.edit == true
    );
    let checkEditGoal = this.editDetailSection.goal.find((e) => e.edit == true);

    if (!checkEditLeadSentence && !checkEditGoal) {
      next();
      await this.handleGetDetailSection();
      if (
        this.detailsSection.conversation &&
        this.detailsSection.conversation.length == 0
      ) {
        await this.handleCreateConversation();
      }
      this.setDefault();
    } else {
      this.editDetailSection.statusEdit = true;
      this.redirect = to;
      this.redirectFrom = from;
      NProgress.done();
      next(false);
    }
  },
  beforeRouteLeave(to, from, next) {
    let checkEditLeadSentence = this.editDetailSection.lead_sentence.find(
      (e) => e.edit == true
    );
    let checkEditGoal = this.editDetailSection.goal.find((e) => e.edit == true);
    if (!checkEditLeadSentence && !checkEditGoal) {
      next();
    } else {
      this.editDetailSection.statusEdit = true;
      this.redirect = to;
      next(false);
    }
  },
  async created() {
    await this.setDefault();
  },

  methods: {
    async handleCreateConversation() {
      let params = {
        section_id: this.$route.params.section,
      };
      await createConversation(params);
    },
    onClickEditSectionTitle() {
      // this.$refs.titleSection.focus()
      // console.log("titleSection: ",this.$refs.titleSection.focus)
      this.editSection = true;
      this.$nextTick(this.$refs.titleSection.focus);
    },
    onClickEditSectionTitleKana() {
      this.editSectionKana = true;
      this.$nextTick(this.$refs.titleSectionKana.focus);
    },
    handleNoComfirm() {
      this.editDetailSection.statusEdit = false;
    },
    handleCancelUpdate() {
      this.editSection = false;
      this.title = this.detailsSection.title;
    },
    async handleYesConfirm() {
      const { isEdit } = this.editDetailSection;
      await this.$refs[isEdit].handleUpdate().then(() => {
        this.editDetailSection.statusEdit = false;
        if (this.redirect.name) {
          this.$router.push(this.redirect).catch(() => console.log());
        }
      });
    },
    async setDefault() {
      await this.handleGetDetailSection();
      if (this.detailsSection.conversation.length == 0) {
        await this.handleCreateConversation();
        this.setDefault();
      } else {
        this.title = this.detailsSection.title;
        this.titleKana = this.detailsSection.titleKana;

        this.editDetailSection.lead_sentence.forEach(
          (e) =>
            (e.value = this.detailsSection.lead_sentence[e.key]
              ? this.detailsSection.lead_sentence[e.key]
              : "")
        );

        this.editDetailSection.goal.forEach(
          (e) =>
            (e.value = this.detailsSection.goal[e.key]
              ? this.detailsSection.goal[e.key]
              : "")
        );
      }
    },
    async handleUpdateSection() {
      let params = {
        sub_key: this.$route.params.chapter,
        id: this.$route.params.section,
        title: this.title,
      };
      this.loaddingEditSectionTitle = true;
      await updateSection(params)
        .then(async () => {
          await this.setDefault();
          this.editSection = false;
          this.loaddingEditSectionTitle = false;
        })
        .catch(() => {
          this.loaddingEditSectionTitle = false;
        });
      // this.editSection = false;
      // this.loaddingEditSectionTitle = false;
    },
    async handleUpdateSectionKana() {
      let params = {
        sub_key: this.$route.params.chapter,
        id: this.$route.params.section,
        titleKana: this.titleKana,
      };
      this.loaddingEditSectionTitleKana = true;
      await updateSection(params)
        .then(async () => {
          await this.setDefault();
          this.editSectionKana = false;
          this.loaddingEditSectionTitleKana = false;
        })
        .catch(() => {
          this.loaddingEditSectionTitleKana = false;
        });
    },
    async handleUpdateSectionTitleKana() {
      let params = {
        sub_key: this.$route.params.chapter,
        id: this.$route.params.section,
        titleKana: this.titleKana,
      };
      this.loaddingEditSectionTitleKana = true;
      await updateSection(params)
        .then(async () => {
          await this.setDefault();
          this.editSection = false;
          this.loaddingEditSectionTitleKana = false;
        })
        .catch(() => {
          this.loaddingEditSectionTitleKana = false;
        });
    },
  },
};
</script>
